import { render, staticRenderFns } from "./configurationUpdate.vue?vue&type=template&id=00dec38b&"
import script from "./configurationUpdate.vue?vue&type=script&lang=js&"
export * from "./configurationUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports